module.exports = __webpack_public_path__ + "img/side-icon-53.6a797a19.svg";